import React from "react";
import "./LoadingOverlay.css";
import maestrasGif from "../../static/Maestras.gif"; // Import GIF

const LoadingOverlay = () => (
  <div className="loading-overlay">
    <div className="loading-container">
      <img src={maestrasGif} alt="Cargando..." className="loading-spinner" />
    </div>
  </div>
);

export default LoadingOverlay;
